import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cb94bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlatSearchCondition" }

import { reactive, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import PriceRange from '../common/PriceRange.vue'
import { isEN } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const platformType = computed(() => store.state.bussiness.platformType)
const model = reactive(store.state.bussiness.platCondition)

// RESET_CONDITION

watch(() => platformType.value, (val) => {
  store.commit('bussiness/RESET_CONDITION')
})

// 排序选项
const sortData: any = {
  // 淘宝
  TB: [
    {
      label: '综合',
      value: ''
    },
    {
      label: '销量',
      value: 'sale-desc'
    },
    {
      label: '信用',
      value: 'credit-desc'
    },
    {
      label: '价格',
      value: 'price-desc'
    }
  ],
  // 天猫
  TM: [
    {
      label: '综合',
      value: ''
    },
    {
      label: '人气',
      value: 'rq'
    },
    {
      label: '新品',
      value: 'new'
    },
    {
      label: '销量',
      value: 'd'
    },
    {
      label: '价格',
      value: 'p'
    }
  ],
  // 1688
  AM: [
    {
      label: '综合',
      value: ''
    },
    {
      label: '成交额',
      value: 'va_rmdarkgmv30'
    },
    {
      label: '价格',
      value: 'price'
    }
  ] // 1688
  // WS: [
  //   {
  //     label: '综合',
  //     value: 'all-desc'
  //   },
  //   {
  //     label: '销量',
  //     value: 'volume-desc'
  //   },
  //   {
  //     label: '人气',
  //     value: 'renqi-desc'
  //   },
  //   {
  //     label: '价格',
  //     value: 'pifa-desc'
  //   }
  // ]
}

// 其他条件选项
const otherData: any = {
  // 淘宝
  TB: [
    {
      label: '包邮',
      value: 'baoyou=1'
    },
    {
      label: '赠送退货运费险',
      value: 'auction_tag[]=385'
    },
    {
      label: '新品',
      value: 'auction_tag[]=1154'
    },
    {
      label: '正品保障',
      value: 'user_type=1'
    },
    {
      label: '公益宝贝',
      value: 'gybb=1'
    },
    {
      label: '7+天内退货',
      value: 'auction_tag[]=4806'
    }
  ],
  // 天猫
  TM: [
    {
      label: '包邮',
      value: 'post_fee=-1'
    },
    {
      label: '折扣',
      value: 'miaosha=1'
    },
    {
      label: '搭配满减',
      value: 'combo=1'
    },
    {
      label: '满就减',
      value: 'filter_mj=1'
    },
    {
      label: '货到付款',
      value: 'support_cod=1'
    }
  ],
  // 1688
  AM: [
    {
      label: '48小时内发货',
      value: 'extendProperties=buyerProtection:essxsfh,buyerProtection:ssbxsfh'
    },
    {
      label: '实力商家',
      value: 'memberTags=205185'
    },
    {
      label: '超级工厂',
      value: 'memberTags=3938689'
    },
    {
      label: '加工定制',
      value: 'offerTags=1803842'
    }
  ]
  // WS: [
  //   {
  //     label: '合作档口',
  //     value: 'hz=1'
  //   }
  // ]
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _unref(model),
      inline: true,
      "label-width": _unref(isEN)() ? '100px' : '90px'
    }, {
      default: _withCtx(() => [
        (sortData[_unref(platformType)]?.length)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('排序')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(model).sort,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).sort) = $event)),
                  style: _normalizeStyle(_unref(isEN)() ? 'width: 370px;' : '')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortData[_unref(platformType)], (v) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: v.value,
                        label: v.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)(v.label)), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "style"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('价格区间')
        }, {
          default: _withCtx(() => [
            _createVNode(PriceRange, {
              min: _unref(model).startPrice,
              "onUpdate:min": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).startPrice) = $event)),
              max: _unref(model).endPrice,
              "onUpdate:max": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).endPrice) = $event))
            }, null, 8, ["min", "max"])
          ]),
          _: 1
        }, 8, ["label"]),
        (otherData[_unref(platformType)]?.length)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: _unref(t)('其他条件')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _unref(model).other,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).other) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherData[_unref(platformType)], (v) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: v.value,
                        label: v.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)(v.label)), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "label-width"])
  ]))
}
}

})